import {
	Image,
	Row,
	Col
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faChevronLeft,
	faChevronRight
} from '@fortawesome/free-solid-svg-icons'
import Job from './Job'

interface EventJobsProps {
  props: any
}

const EventJobs: React.FC<EventJobsProps> = (eventProps: EventJobsProps) => {
	const props: any = eventProps.props
	const jobs = props.jobs.jobs

	const calculatePagination = (): any => {
		const tempPagination: any = {}
		const currentPage: number = parseInt(typeof props.filters.page !== 'undefined' ? props.filters.page as string : '1')
		tempPagination.prev = false
		if (currentPage > 1) {
			tempPagination.prev = true
		}

		const numOfPage = Math.ceil(props.jobs.jobAggregate.aggregate.count / 10)
		tempPagination.pagi = []

		if (numOfPage < 6) {
			tempPagination.pagi = Array.from(Array(numOfPage), (e, i) => { return i + 1 })
		} else {
			if (currentPage < 3) {
				tempPagination.pagi = Array.from(Array(6), (e, i) => { return i + 1 })
				tempPagination.pagi.push('dotted')
				tempPagination.pagi.push(numOfPage)
			} else {
				const tempPagiItems: any = []

				if (currentPage - 1 > 1) {
					if (currentPage - 2 !== 1) {
						tempPagiItems.push(1)
						if (currentPage - 2 !== 1) {
							tempPagiItems.push('dotted')
						}
					}
					tempPagiItems.push(currentPage - 2)
				}

				if (currentPage - 1 > 1) {
					tempPagiItems.push(currentPage - 1)
				}

				tempPagiItems.push(currentPage)
				if (currentPage + 1 <= numOfPage) {
					tempPagiItems.push(currentPage + 1)
				}
				if (currentPage + 2 <= numOfPage) {
					tempPagiItems.push(currentPage + 2)
					if (currentPage + 2 !== numOfPage) {
						if (currentPage + 3 < numOfPage) {
							tempPagiItems.push('dotted')
						}
						tempPagiItems.push(numOfPage)
					}
				}

				tempPagination.pagi = tempPagiItems
			}
		}

		tempPagination.next = false
		if (currentPage < numOfPage) {
			tempPagination.next = true
		}
		return tempPagination
	}

	const pagination: any = calculatePagination()
	const getPaginationLink = (page: string): string => {
		const keyword: string = props.filters.keyword as string
		const jobCategories: string = props.filters.jobCategories as string
		const hashtag: string = props.filters.hashtag.join(',') as string
		return `/event/${props.eventId as string}?page=${page}&q=${keyword}&c=${jobCategories}&hashtag=${hashtag}&layout=LIST`
	}

	return (
		<>
			<Row>
				<Col>
					<Image width='100%' src={props.event.banner} style={{ borderRadius: '10px' }} alt='' />
				</Col>
			</Row>
			<Row>
				<Col>
					<br />
					{jobs.length > 0
						? jobs.map((job: any, index: number) => {
							return (
								<div key={index}>
									<Job job={job} showAvatar={false} withBorder query={`event=${props.eventId as string}`} />
								</div>
							)
						})
						: (
							<div>
								<Row>
									<Col style={{ textAlign: 'center' }}>
										<br />
										<p>We did not find any job matches for your search!</p>
										<p>Try a different keywords or <a href={`/event/${props.eventId as string}`}>Click Here</a> to view all jobs.</p>
										<br />
									</Col>
								</Row>
							</div>
						)}
				</Col>
			</Row>
			<div style={{ textAlign: 'center' }}>
				<br />

				<nav aria-label='Page navigation example'>
					<ul className='pagination justify-content-center pagination-sm'>
						<li className={pagination.prev === true ? 'page-item' : 'page-item disabled'}>
							<a className='page-link' href={getPaginationLink((parseInt(props.filters.page) - 1).toString())} aria-disabled='true'>
								<FontAwesomeIcon icon={faChevronLeft} width='12px' />
							</a>
						</li>
						{pagination.pagi.map((pagi: any, index: number) => {
							return (
								<li key={index} className={pagi === 'dotted' ? 'page-item disabled' : (pagi === parseInt(props.filters.page) ? 'page-item active' : 'page-item')}>
									<a className='page-link' href={getPaginationLink(pagi.toString())}>{pagi === 'dotted' ? '...' : pagi}</a>
								</li>
							)
						})}
						<li className={pagination.next === true ? 'page-item' : 'page-item disabled'}>
							<a className='page-link' href={getPaginationLink((parseInt(props.filters.page) + 1).toString())}>
								<FontAwesomeIcon icon={faChevronRight} width='12px' />
							</a>
						</li>
					</ul>
				</nav>

			</div>
		</>
	)
}

export default EventJobs
